import { Component, OnDestroy, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitService } from 'src/app/services/unit.service';
import { UtilsService } from 'src/app/services/utils.service';

declare const $: any;

@Component({
    selector: 'app-unit-add',
    templateUrl: './unit-add.component.html',
    styleUrls: ['./unit-add.component.css']
})
export class UnitAddComponent {
    constructor(
        private fb: FormBuilder,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
        private apiUnit: UnitService,
        private router: Router,
    ) { }

    formModelData = {
        unit: null,
        plates: null,
        type: "",
        has_federal_plate: false,
        peso_bruto: "",
        numero_motor: "",
        unit_year: null,
        last_verification_date: null,
        next_verification_date: null,
        verification_evidence: null,
        autogafa_evidence: null,
        permit_type_id: "",
        permit_number: null,
        vehicle_configuration_id: "",
        insurer_id: "",
        policy_number: null,
        liability_insurer_id: "",
        liability_policy_number: null,
        environmental_insurer_id: "",
        environmental_policy_number: null,
    }

    verificationEvidencePreviewUrl: string | null = null
    autogafaEvidencePreviewUrl: string | null = null

    permitTypes: any[] = []
    insurers: any[] = []
    vehicleConfigurations: any[] = []

    unitForm!: FormGroup

    ngOnInit(): void {

        this.unitForm = this.fb.group({
            type: ['', Validators.required],
            unit: ['', Validators.required],
            plates: ['', Validators.required],
            has_federal_plate: [false, Validators.required],
            peso_bruto: [''],
            numero_motor: [''],
            unit_year: ['', Validators.required],
            last_verification_date: ['', Validators.required],
            next_verification_date: ['', Validators.required],
            verification_evidence: [null, Validators.required],
            autogafa_evidence: [null, Validators.required],
            permit_type_id: ['', Validators.required],
            permit_number: ['', Validators.required],
            vehicle_configuration_id: ['', Validators.required],
            insurer_id: ['', Validators.required],
            policy_number: ['', Validators.required],
            liability_insurer_id: ['', Validators.required],
            liability_policy_number: ['', Validators.required],
            environmental_insurer_id: [''],
            environmental_policy_number: [''],
        })

        this.loadCatalogs()
    }

    ngOnDestroy(): void {
        if (this.verificationEvidencePreviewUrl) {
            URL.revokeObjectURL(this.verificationEvidencePreviewUrl)
            this.verificationEvidencePreviewUrl = null
        }
        if (this.autogafaEvidencePreviewUrl) {
            URL.revokeObjectURL(this.autogafaEvidencePreviewUrl)
            this.autogafaEvidencePreviewUrl = null
        }
    }

    loadCatalogs() {
        this.apiUnit.getPermitTypes().subscribe((resp: any) => {
            this.permitTypes = resp || []
        })
        this.apiUnit.getInsurers().subscribe((resp: any) => {
            this.insurers = resp || []
        })
        this.apiUnit.getVehicleConfigurations().subscribe((resp: any) => {
            this.vehicleConfigurations = resp || []
        })
    }

    onFileChange(event: any, key: string) {
        const file = event?.target?.files?.[0]
        if (file) {
            ;(this.formModelData as any)[key] = file

            if (key === 'verification_evidence') {
                if (this.verificationEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.verificationEvidencePreviewUrl)
                }
                this.verificationEvidencePreviewUrl = URL.createObjectURL(file)
            }
            if (key === 'autogafa_evidence') {
                if (this.autogafaEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.autogafaEvidencePreviewUrl)
                }
                this.autogafaEvidencePreviewUrl = URL.createObjectURL(file)
            }

            this.unitForm.patchValue({ [key]: file })
            this.unitForm.get(key)?.markAsDirty()
        }
    }

    addUnit() {
        if (this.unitForm.valid) {
            this.spinner.show()
            const payload: any = { ...this.formModelData }
            payload.has_federal_plate = payload.has_federal_plate ? '1' : '0'

            this.apiUnit.addUnitForm(payload).subscribe((resp: any) => {
                this.spinner.hide()
                $("#formUnit")[0].reset()

                if (this.verificationEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.verificationEvidencePreviewUrl)
                    this.verificationEvidencePreviewUrl = null
                }
                if (this.autogafaEvidencePreviewUrl) {
                    URL.revokeObjectURL(this.autogafaEvidencePreviewUrl)
                    this.autogafaEvidencePreviewUrl = null
                }

                this.formModelData = {
                    unit: null,
                    plates: null,
                    type: "",
                    has_federal_plate: false,
                    peso_bruto: "",
                    numero_motor: "",
                    unit_year: null,
                    last_verification_date: null,
                    next_verification_date: null,
                    verification_evidence: null,
                    autogafa_evidence: null,
                    permit_type_id: "",
                    permit_number: null,
                    vehicle_configuration_id: "",
                    insurer_id: "",
                    policy_number: null,
                    liability_insurer_id: "",
                    liability_policy_number: null,
                    environmental_insurer_id: "",
                    environmental_policy_number: null,
                }
                this.unitForm.reset()
                this.utils.alertSwal({ title: "Exitoso", text: resp.msg, icon: "success" })

                this.router.navigateByUrl('/unit/list')

            }, (error) => {
                this.spinner.hide()
                this.utils.alertSwal({ title: "Error!", text: "Se ha presentado un error al insertar conductor", icon: "error" })
            })
        } else {

            this.utils.alertSwal({ title: "Advertencia", text: "Verifique que la información se encuentre completa.", icon: "warning" })
        }
    }

    get registerFormControl() {
        return this.unitForm.controls;
    }
}
